import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActionCreators from '../../ActionCreator';
import GetDemoScreen from './GetDemoScreen';

const GetDemoScreenContainer = ({
  reduxStatus,
  reduxError,
  actions: {
    sendQuestionFlowReset,
    sendQuestionFlowRequest,
  },
}) => {
  useEffect(() => {
    sendQuestionFlowReset();

    return () => {
      sendQuestionFlowReset();
    };
  }, [sendQuestionFlowReset]);
  const onSendQuestion = (data) => {
    sendQuestionFlowRequest(data);
  };
  return (
    <GetDemoScreen
      reduxStatus={reduxStatus}
      reduxError={reduxError}
      onSendQuestion={onSendQuestion}
    />
  );
};

GetDemoScreenContainer.propTypes = {
  reduxStatus: PropTypes.string,
  reduxError: PropTypes.string,
  actions: PropTypes.shape({
    sendQuestionFlowReset: PropTypes.func,
    sendQuestionFlowRequest: PropTypes.func,
  }).isRequired,
};

GetDemoScreenContainer.defaultProps = {
  reduxStatus: null,
  reduxError: null,
};

const mapStateToProps = state => ({
  reduxStatus: state.home.reduxStatus,
  reduxError: state.home.error,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    ...ActionCreators,
  }, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GetDemoScreenContainer);
